'use client';

// Components
import Hero from '@src/components/organism/karir/hero';
import ListJob from '@src/components/organism/karir/list-job';

// Components shared
import Navbar from '@src/components/organism/shared/navbar';
import NavbarMobile from '@src/components/organism/shared/navbar-mobile';
import Footer from '@src/components/organism/shared/footer';
import GoldenProperty from '@src/components/organism/shared/golder-property';

const Karir = () => {
  return (
    <div className="bg-[#FAFAFA]">
      <Navbar />
      <div className="hidden dd2-xl:block">
        <NavbarMobile />
      </div>

      <Hero />
      <ListJob />
      <GoldenProperty />
      <Footer />
    </div>
  );
};

export default Karir;
